/**
 * Country Icon Formatter.
 * @param {*} value
 * @returns {String|*}
 */
window.countryIconFormatter = function(value) {
    if (value) {
        return '<span class="fi fi-'+value+'"></i>';
    }
    return '';
};
